module.exports = __webpack_public_path__ + "img/Standardvideo.6d70e516.png";